import { PaymentMethods, type PaymentMethod } from 'src/constants/PaymentMethod';

export function isTransferPayment(paymentMethod: PaymentMethod | void): boolean {
    return paymentMethod === PaymentMethods.TRANSFER;
}
